import { AbstractWeb3AuthWalletConnector } from './AbstractWeb3AuthWalletConnector.js';
export class FacebookSocialWalletConnector extends AbstractWeb3AuthWalletConnector {
    constructor() {
        super(...arguments);
        this.id = 'facebook';
        this.name = 'Facebook';
        this.loginProvider = 'facebook';
    }
}
